export function validarDataViagem(dataViagem, feriados, diasUteis) {

    // Cria uma nova data a partir dos componentes de ano, mês e dia
    let [ano, mes, dia] = dataViagem.split('-');
    // O mês é subtraído por 1 porque os meses em JavaScript são indexados de 0 (Janeiro = 0)
    let data = new Date(ano, mes - 1, dia);

    let hoje = new Date(); // Data atual
    hoje.setHours(0, 0, 0, 0); // Define o tempo para meia-noite

    let dataCorrente = getPrimeiraDataViagemPermitida(feriados, diasUteis);
    
    // Retorna verdadeiro se a data de viagem for superior a três dias úteis da data atual
    return data > dataCorrente;
}

// função para verificar se um dia é feriado
function ehFeriado(data, feriados) {

    return feriados.some(feriado => {
        let [fAno, fMes, fDia] = feriado.data.split('-');
        let feriadoData = new Date(fAno, fMes - 1, fDia);
        feriadoData.setHours(0, 0, 0, 0); // Ajusta o horário do feriado para meia-noite
        return feriadoData.getTime() === data.getTime();
    });
}

// pega a primeira data permitida para solicitar viagem
// desconsidera sabado, domingo e feriados
export function getPrimeiraDataViagemPermitida(feriados, diasUteis) {

    let hoje = new Date(); // Data atual
    hoje.setHours(0, 0, 0, 0);

    // Calcula a qtde de dias úteis a partir da data atual
    let diasUteisContados = 0;
    let dataCorrente = new Date(hoje);
    
    while (diasUteisContados < diasUteis) {

        dataCorrente.setDate(dataCorrente.getDate() + 1);
        // Verifica se é fim de semana ou feriado
        if (dataCorrente.getDay() === 0 || dataCorrente.getDay() === 6 || ehFeriado(dataCorrente, feriados)) {
            continue; // Pula finais de semana e feriados
        }

        diasUteisContados++;
    }

    return dataCorrente;
}

export function isDataPassada(data) {
    // Converte a string de data para um objeto Date
    let [ano, mes, dia] = data.split('-');
    let dataFornecida = new Date(ano, mes - 1, dia); // O mês é subtraído por 1 pois o índice começa em 0
    dataFornecida.setHours(0, 0, 0, 0); // Define a hora para meia-noite para evitar problemas de comparação

    // Obtém a data atual e define a hora para meia-noite
    let hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    // Compara as duas datas
    return dataFornecida < hoje;
}

export function getDataHoje() {
    // Obtém a data atual
    let hoje = new Date();

    // Formata a data como YYYY-MM-DD
    let dia = String(hoje.getDate()).padStart(2, '0');
    let mes = String(hoje.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
    let ano = hoje.getFullYear();

    hoje = `${ano}-${mes}-${dia}`;

    return hoje
}

export function formatarDataISO(data) {
    // Extrai o ano, mês e dia do objeto Date
    let ano = data.getFullYear();
    let mes = String(data.getMonth() + 1).padStart(2, '0'); // Mês é indexado de 0 a 11, então somamos 1
    let dia = String(data.getDate()).padStart(2, '0'); // PadStart garante que o dia tenha dois dígitos

    // Formata a data no formato "aaaa-mm-dd"
    return `${ano}-${mes}-${dia}`;
}

export function formatarDataBR(data) {
    // Divide a data em partes usando o caractere '-' como delimitador
    let partes = data.split('-');

    // Reorganiza as partes no formato 'dd-mm-aaaa'
    let dia = partes[2];
    let mes = partes[1];
    let ano = partes[0];

    // Retorna a data formatada como string
    return `${dia}/${mes}/${ano}`;
}

export function dataMaiorOuIgual(data1, data2) {
    // Converte as strings de data para objetos Date
    let dataObj1 = new Date(data1);
    let dataObj2 = new Date(data2);

    // Compara as datas
    return dataObj2 >= dataObj1;
}

export function dataMaior(data1, data2) {
    // Converte as strings de data para objetos Date
    let dataObj1 = new Date(data1);
    let dataObj2 = new Date(data2);

    // Compara as datas
    return dataObj2 > dataObj1;
}

export function dataMenor(data1, data2) {
    // Converte as strings de data para objetos Date
    let dataObj1 = new Date(data1);
    let dataObj2 = new Date(data2);

    // Compara as datas
    return dataObj1 < dataObj2;
}

export function calcularDataMinima(dias) {
    let today = new Date();
    today.setDate(today.getDate() + dias);

    return today;
}

export function validarEmail(email) {
    // Expressão regular para validar o formato básico de um e-mail
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}